const messages = {
    en: {
        message: {
            jwtExpired: "Your login expired, you need to login again",
            tokenExpired: "Your desk login expired, you need to login again",
            userOnline: "You logged in with desk",
            userOffline:
                "You logged in with the application, before sending content to desk you'll need to login again",
            cannotChangePwd: "To change your password you should login again",
            selectConfiguration: "Please select a configuration",
            selectProject: "Please select a package",
            tooManyArticles: "Only one article per package is allowed"
        },
        prj: {
            BUTTON_ADD: "Add a new package",
            BUTTON_MODIFY: "Modify the selected package",
            BUTTON_REMOVE: "Remove the selected package",
            BUTTON_SEND:
                "Send all the modified contents of the selected package",
            TITLE: "Packages",
            TOOLTIP_SENT: "content to be sent",
            TOOLTIP_ALREADY_SENT: "content already sent",
            TOOLTIP_SENT_PL: "contents to be sent",
            TOOLTIP_ALREADY_SENT_PL: "contents already sent",
            TOOLTIP_LASTSEND: "Last send",
            TOOLTIP_CREATED: "Created on "
        },
        file: {
            BUTTON_ADD: "Add a new article",
            BUTTON_MODIFY: "Modify the selected content",
            BUTTON_REMOVE: "Delete the selected content (shift deletes all)",
            BUTTON_SEND: "Send the selected content",
            BUTTON_UPLOAD: "Upload a new image (or pdf)",
            TITLE: "Contents"
        },
        preview: {
            TITLE: "Preview"
        },
        menu: {
            SHOW_LOG: "Show log",
            HIDE_LOG: "Hide log",
            LOGOUT: "Logout",
            CHANGE_PWD: "Change password"
        },
        editor: {
            BUTTON_SAVE: "Save",
            BUTTON_DISCARD: "Discard",
            FIELD_DESTINATION: "Destination",
            FIELD_NAME: "Name",
            FIELD_HEADLINE: "Headline",
            FIELD_LEAD: "Lead",
            FIELD_BODY: "Body",
            COUNTER_WORDS: "Words",
            COUNTER_CHARS: "Chars",
            DISCARD_MSG: "Discard the changes?",
            FIELD_HEADLINE_MAXCHARS:
                "You exceeded the maximum number of chars ({count} > {maxChars})"
        },
        prjeditor: {
            TITLE: "Package options",
            FIELD_NAME: "Name",
            FIELD_NAME_PH: "Project Name",
            FIELD_SOURCE: "Source",
            FIELD_SOURCE_PH: "Pictures IPTC Source",
            FIELD_WORD_CONVERT: "Convert Word Documents to Articles",
            DISCARD_MSG: "Discard the changes?"
        },
        log: {
            TITLE: "Log"
        },
        login: {
            TITLE: "Login",
            FIELD_NAME: "Login Name",
            FIELD_PWD: "Password",
            BUTTON_LOGIN: "Login",
            BUTTON_RESET: "Reset",
            RESET_REMINDER: "-- If you don't rememver the password --",
            ERR_WRONG_USER_OR_LOGIN: "wrong user or password",
            ERR_REMOTE_UNREACHABLE: "cannot contact the remote desk API",
            ERR_LOCAL_UNREACHABLE: "cannot contact the local API",
            ERR_REMOTE_ERROR: "remote error: ",
            ERR_PASSWORD_EMPTY: "remote error: "
        },
        changepwd: {
            TITLE: "Change password",
            FIELD_OLD_PWD: "Old password",
            FIELD_NEW_PWD: "New password",
            FIELD_REPEAT_PWD: "Confirm password",
            BUTTON_CHANGE: "Change it",
            BUTTON_DISMISS: "Dimiss",
            CHANGE_ERRORS_TEXT: "Please correct the following error(s):",
            ERR_OLD_PWD_CANT_BE_BLANK: "Old password can't be blank",
            ERR_NEW_PWD_CANT_BE_BLANK: "New password can't be blank",
            ERR_NEW_PWD_TOO_SHORT:
                "New password is too short, minimum is %{count}",
            ERR_NEW_PWD_ALPHABETIC_TOO_SHORT:
                "New password must contain least %{count} alphabetic characters",
            ERR_NEW_PWD_NUMERIC_TOO_SHORT:
                "New password must contain least %{count} numeric characters",
            ERR_NEW_PWD_SPECIALS_TOO_SHORT:
                "New password must contain least %{count} characters in the following set %{chars}",
            ERR_NEW_PWD_MIX_CASE:
                "New password must contain at least one uppercase and one lowercase characters",
            ERR_RPT_PWD_MISMATCH:
                "The confirmed password does not match the new password",
            ERR_SERVER_PWD_POLICY_RULES:
                "The new password does not match the password policy",
            ERR_SERVER_OLD_PWD_NOMATCH: "The old password does not match",
            MSG_PASSWORD_CHANGED: "The password has been changed"
        },
        resetpwd: {
            TITLE: "Reset password",
            FIELD_EMAIL: "Email",
            BUTTON_SEND: "Send request",
            BUTTON_DISMISS: "Dimiss",
            MSG_EMAIL_SENT: "The reset password email has been sent"
        },
        validation: {
            failed: "Validation failed for '{name}': {msg}",
            error: "Check field '{field}'"
        }
    },
    it: {
        message: {
            jwtExpired: "Il tuo accesso e' scaduto, devi accedere di nuovo",
            tokenExpired:
                "Il tuo accesso a desk e' scaduto, devi accedere di nuovo",
            userOnline: "Sei collegato a desk",
            userOffline:
                "Non sei collegato a desk, per mandare i contenuti dovrai accedere",
            cannotChangePwd:
                "Per effettuare il cambio password devi effettuare di nuovo la login",
            selectConfiguration: "Per favore seleziona una configurazione",
            selectProject: "Per favore seleziona un pacchetto",
            tooManyArticles: "Un solo articolo per pacchetto è permesso"
        },
        prj: {
            BUTTON_ADD: "Aggiungi un nuovo pacchetto",
            BUTTON_MODIFY: "Modifica il pacchetto selezionato",
            BUTTON_REMOVE: "Rimuovi il pacchetto selezionato",
            BUTTON_SEND:
                "Manda tutti i contenuti modificati del pacchetto selezionato",
            TITLE: "Pacchetti",
            TOOLTIP_SENT: "contenuto da mandare",
            TOOLTIP_ALREADY_SENT: "contenuto già mandato",
            TOOLTIP_SENT_PL: "contenuti da mandare",
            TOOLTIP_ALREADY_SENT_PL: "contenuti già mandati",
            TOOLTIP_LASTSEND: "Ultimo invio",
            TOOLTIP_CREATED: "Creato il "
        },
        file: {
            BUTTON_ADD: "Aggiungi un nuovo articolo",
            BUTTON_MODIFY: "Modifica il contenuto selezionato",
            BUTTON_REMOVE:
                "Rimuovi il contenuto selezionato (se tieni premuto il tasto 'shift' verranno cancellati tutti)",
            BUTTON_SEND: "Manda il contenuto selezionato",
            BUTTON_UPLOAD: "Carica una nuova immagine (o pdf)",
            TITLE: "Contenuti"
        },
        preview: {
            TITLE: "Anteprima"
        },
        menu: {
            SHOW_LOG: "Mostra registro",
            HIDE_LOG: "Nascondi registro",
            LOGOUT: "Esci",
            CHANGE_PWD: "Cambio password"
        },
        editor: {
            BUTTON_SAVE: "Salva",
            BUTTON_DISCARD: "Annulla",
            FIELD_DESTINATION: "Destinazione",
            FIELD_NAME: "Nome",
            FIELD_HEADLINE: "Titolo",
            FIELD_LEAD: "Sommario",
            FIELD_BODY: "Testo",
            COUNTER_WORDS: "Parole",
            COUNTER_CHARS: "Caratteri",
            DISCARD_MSG: "Annullare le modifiche?",
            FIELD_HEADLINE_MAXCHARS:
                "Hai superato il numero massimo di caratteri ({count} > {maxChars})"
        },
        prjeditor: {
            TITLE: "Opzioni pacchetto",
            FIELD_NAME: "Nome",
            FIELD_NAME_PH: "Nome pacchetto",
            FIELD_SOURCE: "Sorgente",
            FIELD_SOURCE_PH: "Sorgente IPTC per le immagini",
            FIELD_WORD_CONVERT: "Converti i documenti word in articoli",
            DISCARD_MSG: "Annullare le modifiche?"
        },
        log: {
            TITLE: "Registro"
        },
        login: {
            TITLE: "Accesso",
            FIELD_NAME: "Nome utente",
            FIELD_PWD: "Password",
            BUTTON_LOGIN: "Accedi",
            BUTTON_RESET: "Reimposta",
            RESET_REMINDER: "-- Se non ricordi la password --",
            ERR_WRONG_USER_OR_LOGIN: "Nome utente o password sbagliati",
            ERR_REMOTE_UNREACHABLE: "Non e' possibile contattare desk",
            ERR_LOCAL_UNREACHABLE: "Non e' possibile contattare in server",
            ERR_REMOTE_ERROR: "Errore dal server: ",
            ERR_PASSWORD_EMPTY: "La password e' vuota"
        },
        changepwd: {
            TITLE: "Cambio password",
            FIELD_OLD_PWD: "Vecchia password",
            FIELD_NEW_PWD: "Nuova password",
            FIELD_REPEAT_PWD: "Conferma password",
            BUTTON_CHANGE: "Cambiala",
            BUTTON_DISMISS: "Annulla",
            CHANGE_ERRORS_TEXT: "Per favore correggi i seguenti errori:",
            ERR_OLD_PWD_CANT_BE_BLANK:
                "La vecchia password non puo' essere vuota",
            ERR_NEW_PWD_CANT_BE_BLANK:
                "La nuova password non puo' essere vuota",
            ERR_NEW_PWD_TOO_SHORT:
                "La nuova password è troppo corta, deve avere almeno %{count} caratteri",
            ERR_NEW_PWD_ALPHABETIC_TOO_SHORT:
                "La nuova password deve avere almeno %{count} caratteri alfabetici",
            ERR_NEW_PWD_NUMERIC_TOO_SHORT:
                "La nuova password deve avere almeno %{count} caratteri numerici",
            ERR_NEW_PWD_SPECIALS_TOO_SHORT:
                "La nuova password deve avere almeno %{count} tra i seguenti caratteri: %{chars}",
            ERR_NEW_PWD_MIX_CASE:
                "La nuova password deve avere sia caratteri minuscoli che caratteri maiuscoli",
            ERR_RPT_PWD_MISMATCH:
                "La password di conferma non è uguale alla nuova password",
            ERR_SERVER_PWD_POLICY_RULES:
                "La nuova password non soddisfa le regole sulle nuove password",
            ERR_SERVER_OLD_PWD_NOMATCH: "La vecchia password non corrisponde",
            MSG_PASSWORD_CHANGED: "La password è stata cambiata"
        },
        resetpwd: {
            TITLE: "Reimposta password",
            FIELD_EMAIL: "Email",
            BUTTON_SEND: "Manda richiesta",
            BUTTON_DISMISS: "Annulla",
            MSG_EMAIL_SENT:
                "La mail per la reimpostazione della password è stata mandata"
        },
        validation: {
            failed: "Validazione fallita per '{name}': {msg}",
            error: "Controlla il campo '{field}'"
        }
    }
};

export default messages;
